import {
  FormControl,
  FormLabel,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
} from "@chakra-ui/react"
import { useField } from "formik"
import type React from "react"

interface PCNumberInputProps {
  label: string
  description?: string
  name: string
  [key: string]: any
}

const PCNumberInput: React.FC<PCNumberInputProps> = ({
  label,
  description,
  ...props
}) => {
  const [field, meta, helpers] = useField(props)
  const { setValue } = helpers
  return (
    <FormControl isInvalid={meta.touched && !!meta.error}>
      <FormLabel htmlFor={props.id || props.name}>
        <strong>{label}</strong>
      </FormLabel>
      {description && <p>{description}</p>}
      <NumberInput
        {...field}
        {...props}
        id={props.id || props.name}
        value={field.value}
        onChange={(valueString) => setValue(Number(valueString))}
      >
        <NumberInputField />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>
      {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </FormControl>
  )
}

export default PCNumberInput
